import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme, css } from 'styled-components';
import { compose } from 'recompose';

import { withOffset } from 'Context/LayoutContext';

import { Box } from '../Base';

const Container = styled((props) => <Box {...props} />)`
  ${({ theme: { space, colors }, isBackgroundActiveOnScroll, hasMenuBackground }) => css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: ${colors?.navbarMyCourseBackground ??
      `linear-gradient(to right, #488eff, #80e7ff)`};
      opacity: ${isBackgroundActiveOnScroll ? 1 : 0};
      transition: opacity 0.3s ease-in-out;
      z-index: -1;
    }

    background: ${hasMenuBackground
      ? colors?.navbarMyCourseBackground ?? `linear-gradient(to right, #488eff, #80e7ff)`
      : colors.transparent};

    padding-top: ${space.APP_TOP_OFFSET}px;
    height: ${space.NAVBAR_HEIGHT + space.APP_TOP_OFFSET}px;
  `}
`;

const MenuContainer = ({
  forwardedRef,
  onBackgroundChange,
  hasMenuBackground,
  theme,
  ...props
}) => {
  const { space } = theme;
  const [isBackgroundActiveOnScroll, setIsBackgroundActiveOnScroll] = useState(false);
  const handleScroll = () => {
    const offsetY = window.scrollY;
    if (offsetY >= space.NAVBAR_HEIGHT && !isBackgroundActiveOnScroll) {
      onBackgroundChange(true);
      setIsBackgroundActiveOnScroll(true);
    } else if (offsetY < space.NAVBAR_HEIGHT && isBackgroundActiveOnScroll) {
      onBackgroundChange(false);
      setIsBackgroundActiveOnScroll(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return function cleanup() {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return (
    <Container
      ref={forwardedRef}
      isBackgroundActiveOnScroll={isBackgroundActiveOnScroll}
      hasMenuBackground={hasMenuBackground}
      {...props}
    />
  );
};

MenuContainer.propTypes = {
  onBackgroundChange: PropTypes.func,
  hasMenuBackground: PropTypes.bool,
};

MenuContainer.defaultProps = {
  onBackgroundChange: () => {},
  hasMenuBackground: false,
};

export default compose(withTheme, withOffset)(MenuContainer);
